import axios from "axios";
import { useState } from "react";
import { Request_Post_Axios } from "../../API/index";

export const useAuth = () => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });

  const login = async (userData) => {
    const result = await Request_Post_Axios(`/Login/checkLogin`, {
      userData,
    });

    if (result.status) {
      localStorage.setItem("ID", JSON.stringify(userData.id));
      localStorage.setItem("Token", JSON.stringify(result.data.token));
      return true;
    } else {
      alert("아이디 또는 비밀번호를 재 확인 해 주세요.");
      return false;
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("Token");
  };

  return {
    user,
    isLoggedIn: !!user,
    login,
    logout,
  };
};
